import { Reveal } from "./Reveal";

interface Section { heading: string; body: string[]; }

interface LegalDocProps {
  title: string;
  updated: string;
  sections: Section[];
}

/** Shared layout for long-form legal pages (Privacy, Terms). */
export function LegalDoc({ title, updated, sections }: LegalDocProps) {
  return (
    <>
      <section className="relative overflow-hidden bg-[#0a2d4a] pt-32 pb-16 lg:pt-40">
        <div className="pointer-events-none absolute -top-32 left-1/2 h-80 w-full max-w-[600px] -translate-x-1/2 rounded-full bg-blue-500/20 blur-[120px]" />
        <div className="relative mx-auto max-w-3xl px-5 sm:px-8">
          <h1 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">{title}</h1>
          <p className="mt-3 text-sm text-slate-400">Last updated: {updated}</p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <div className="space-y-10">
            {sections.map((s) => (
              <Reveal key={s.heading}>
                <div>
                  <h2 className="text-lg font-bold text-[#0a2d4a]">{s.heading}</h2>
                  <div className="mt-3 space-y-3">
                    {s.body.map((p, i) => (
                      <p key={i} className="text-[15px] leading-relaxed text-slate-600">{p}</p>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
